// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { inventoryController } from "../../../game_theme/flow_fb/flowController";
import { ComponentButton } from "../../framework/components/ComponentButton";
import { ComponentContainer } from "../../framework/components/ComponentContainer";
import { ComponentPicture } from "../../framework/components/ComponentPicture";
import { tgfComponents } from "../../framework/components/tgfComponents";
import { tgfGraphics } from "../../framework/tgfGraphics";
import { tgfSettings } from "../../framework/tgfSettings";
import { PowerUpSettings } from "../../settings/Settings";
import { SoundManager } from "../../settings/SoundManager";
import { s_buttonpowerbg, s_btn_round_video, s_buttonpower_glow, s_buttonpower_effect, s_redcross } from "../AssetDefinitions/ImageDefinitions";
import { LoadingOverlay } from "../LobbyCode/LoadingOverlay";
import { PowerUpSlot } from "./PowerUpSlotComponent";
tgfSettings.componentDefaults.VideoPowerUpSlotComponent =
    {
        x: 0, y: 0,
        hasClickedRefill: false,
        onUsePowerUpClicked: null,
        components: []
    };
export var VideoPowerUpSlot = function (properties) {
    'use strict';
    this.name = 'VideoPowerUpSlotComponent';
    this.slotContainer = new ComponentContainer();
    this.initialize(tgfSettings.componentDefaults.VideoPowerUpSlotComponent);
    this._powerUpImages = [];
    this.isSelected = false;
    for (var a in properties) {
        this[a] = properties[a];
    }
    this._previousPowerUp = -1;
};
// Inherit the base component
tgfComponents.inherit(VideoPowerUpSlot, PowerUpSlot);
/**
 * The index of the slot
 */
VideoPowerUpSlot.prototype._slotIndex = -1;
VideoPowerUpSlot.prototype._powerUpIndex = -1;
VideoPowerUpSlot.prototype.showPowerUp = function (powerUpIndex) {
    "use strict";
};
VideoPowerUpSlot.prototype._enableInput = function () {
    this.disabled = false;
};
VideoPowerUpSlot.prototype._disableInput = function () {
    this.disabled = true;
};
// Processing required when preparing the component for use
VideoPowerUpSlot.prototype.doPrepare = function () {
    "use strict";
    var i, self = this;
    this.loader = new LoadingOverlay({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2
    });
    this._previousPowerUp = this._powerUpIndex;
    this.loader = new LoadingOverlay({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2
    });
    var powerUpSlotBG1 = new ComponentPicture({
        image: s_buttonpowerbg,
        xScale: 1.07,
        yScale: 1.07
    });
    // This code basically goes through the powerup settings and collects a list of all used unique bgImgs
    var flags = [];
    this.powerUpBGs = [];
    for (i = 0; i < PowerUpSettings.options.length; i++) {
        if (flags[PowerUpSettings.options[i].bgImg.name]) {
            continue; // If already collected this bgimg then ignore
        }
        flags[PowerUpSettings.options[i].bgImg.name] = true; // Mark this BG as already loaded
        this.powerUpBGs.push(PowerUpSettings.options[i].bgImg); // Push it to the array
    }
    this.powerUpSlotBG2Map = [];
    for (var index = 0; index < this.powerUpBGs.length; index++) {
        var element = this.powerUpBGs[index];
        this.powerUpSlotBG2Map[element.name] = (new ComponentPicture({
            image: element,
            alpha: 0,
            xScale: 1.1,
            yScale: 1.1
        }));
    }
    this.powerUpSlotBG2Map["s_btn_round_video.png"] = (new ComponentButton({
        image: s_btn_round_video,
        x: 46,
        y: 52,
        alpha: 0,
        xScale: 1.1,
        yScale: 1.1,
        onClick: function () {
            SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
            self.onPowerupClick();
        }
    }));
    if (this._powerUpIndex >= 0) {
        this.powerUpSlotBG2Map[PowerUpSettings.options[this._powerUpIndex].bgImg.name].alpha = 1;
    }
    else {
        this.powerUpSlotBG2Map["s_btn_round_video.png"].alpha = 1;
    }
    for (var prop in this.powerUpSlotBG2Map) {
        powerUpSlotBG1.addComponent(this.powerUpSlotBG2Map[prop]);
    }
    this._powerUpGlowEffects = [];
    var powerUpSlotGlow = new ComponentPicture({
        image: s_buttonpower_glow,
        xScale: 1,
        yScale: 1,
        alpha: (this._powerUpIndex >= 0) ? 0.3 : 0
    });
    this._powerUpGlowEffects.push(powerUpSlotGlow);
    powerUpSlotBG1.addComponent(powerUpSlotGlow);
    var powerUpSlotEffect = new ComponentPicture({
        image: s_buttonpower_effect,
        xScale: 0.75,
        yScale: 0.75,
        alpha: (this._powerUpIndex >= 0) ? 0.4 : 0
    });
    this._powerUpGlowEffects.push(powerUpSlotEffect);
    powerUpSlotBG1.addComponent(powerUpSlotEffect);
    for (i = 0; i < PowerUpSettings.options.length; i++) {
        var picture = new ComponentPicture({
            image: PowerUpSettings.options[i].image,
            xScale: 1,
            yScale: 1,
            x: 0,
            y: 0,
            alpha: (this._powerUpIndex === i) ? 1 : 0,
            _disabled: true
        });
        this._powerUpImages.push(picture);
        powerUpSlotBG1.addComponent(picture);
    }
    this.slotContainer.addComponent(powerUpSlotBG1);
    //this.startGlow = new ComponentPicture({});
    this.redCross = new ComponentPicture({
        image: s_redcross,
        alpha: 0
    });
    this.slotContainer.addComponent(this.redCross);
    this.addComponent(this.slotContainer);
    // Add the child components
    if (this.components) {
        for (i = 0; i < this.components.length; i += 1) {
            this.addComponent(this.components[i]);
        }
    }
};
VideoPowerUpSlot.prototype.onPowerupClick = function () {
    if (this.hasClickedRefill) {
        return;
    }
    this.hasClickedRefill = true;
    this.onAdSuccess();
    this.onCancelSelection();
    this.onResetingPowerups();
};
VideoPowerUpSlot.prototype.onAdSuccess = function () {
    this.hasClickedRefill = false;
    inventoryController.unlockAllPowerUps();
    this.onRefillPowerups();
};
VideoPowerUpSlot.prototype.onCancelSelection = function () {
};
VideoPowerUpSlot.prototype.onSelection = function () {
};
VideoPowerUpSlot.prototype.animate = function () {
    'use strict';
    for (var index = 0; index < this._powerUpGlowEffects.length; index++) {
        var element = this._powerUpGlowEffects[index];
        element.setAngle(element.angle + 0.005);
    }
};
VideoPowerUpSlot.prototype.setPowerUpIndex = function (powerUpIndex) {
    'use strict';
    this._powerUpIndex = powerUpIndex;
};
VideoPowerUpSlot.prototype.setIndex = function (index) {
    this._slotIndex = index;
};
VideoPowerUpSlot.prototype.getPowerUpIndex = function () {
    'use strict';
    return this._powerUpIndex;
};
VideoPowerUpSlot.prototype.setScale = function (xS, yS) {
    'use strict';
    for (var index = 0; index < this._components.length; index++) {
        var element = this._components[index];
        this._scaleChildren(element, xS, yS);
    }
};
VideoPowerUpSlot.prototype._scaleChildren = function (child, xS, yS) {
    'use strict';
    if (!child._components) {
        return;
    }
    for (var index = 0; index < child._components.length; index++) {
        var element = child._components[index];
        if (element.setScale) {
            element.setScale(element.xScale * xS, element.yScale * yS);
        }
        else {
            element.xScale = (element.xScale * xS);
            element.yScale = (element.yScale * yS);
        }
        if (element.image) {
            element.image.setScale(element.xScale, element.yScale);
        }
        this._scaleChildren(element, xS, yS);
    }
};
VideoPowerUpSlot.prototype.setPosition = function (x, y) {
    'use strict';
    this.slotContainer.setPosition(x, y);
};
